import { useCallback, useState } from "react";
import CreateCharacterMpProvider from "@/core/data-provider/data-mp/create-character/create-character-mp-provider";
import useErrorTranslation from "@/core/helpers/useErrorTranslation";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";

export default function useChangeCamera() {
  const tError = useErrorTranslation();
  const [isPending, setIsPending] = useState(false);
  const [isCompleted, setIsCompleted] = useState<null | boolean>(null);
  const [error, setError] = useState("");

  const changeCamera = useCallback(async (value: string) => {
    try {
      setIsPending(true);

      const response = await CreateCharacterMpProvider.setCamera(value);

      if (response instanceof RpcMpProviderSuccessResponse) {
        setIsCompleted(true);
      } else {
        setIsCompleted(false);
      }
    } catch (e) {
      setIsCompleted(false);
      setError(tError(e.message));
    } finally {
      setIsPending(false);
    }
  }, []);

  return { changeCamera, isPending, isCompleted, error };
}
